import { Form } from "@redriver/cinnamon-mui";
import { disciplineTypesLookup } from "modules/lookups";

const DisciplineTypeCheckboxGroup = (props) => (
  <Form.CheckboxGroup lookup={disciplineTypesLookup} {...props} />
);

export default DisciplineTypeCheckboxGroup;
